import type { Theme } from '../../../styles/theme';
import { IFRAME_CSP } from './constants';
import type { ISanitizedDocx } from './sanitizeDocx';

const buildThemeCss = ({ colors, spacing, shadows }: Theme): string => `
html,body{margin:0;padding:0}
body{background:${colors.background}}
.docx-wrapper{background:${colors.background} !important;padding:${spacing.md} !important;gap:${spacing.md};align-items:flex-start !important;width:fit-content;min-width:100%;box-sizing:border-box}
.docx-wrapper>section.docx{box-shadow:${shadows.md} !important;margin:0 auto !important}`;

export const buildSrcDoc = (
  { styles, html }: ISanitizedDocx,
  theme: Theme
): string =>
  `<!doctype html>
<html><head>
<meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="${IFRAME_CSP}">
<meta name="referrer" content="no-referrer">
${styles.map(css => `<style>${css}</style>`).join('\n')}
<style>${buildThemeCss(theme)}</style>
</head><body>${html}</body></html>`;
